var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-toggle d-flex align-items-center py-5 pl-5 pr-3 text-lg",class:{'selected': _vm.current},on:{"click":_vm.openRelatedTab}},[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"icon-right-open-big pl-5 ml-auto"})],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b55e12e4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/TabToggle.vue
// module id = hUy1
// module chunks = 0